import { money, discountPct, fmtDay, fmtTime, fmtLongDate, COUPON_MSG } from "@/lib/booking";
import { panel } from "./ui";

function Line({ title, value, testid, strong }) {
    return (
        <div className={`flex justify-between gap-4 text-sm ${strong ? "border-t border-ink/10 pt-4 text-ink" : "text-dim"}`}>
            <span>{title}</span><strong data-testid={testid} className={strong ? "text-neon-cyan" : ""}>{value}</strong>
        </div>
    );
}

export function PriceSummary({ tour, slot, date, guests, quote, loading, error, couponCode }) {
    const pct = quote ? discountPct(quote.original_price, quote.unit_price) : 0;
    const when = slot ? `${fmtLongDate(slot.starts_at)} · ${fmtTime(slot.starts_at)}` : date ? `${fmtDay(date)} (a confirmar)` : "—";
    return (
        <aside className={panel + " h-fit space-y-4 lg:sticky lg:top-8"} data-testid="price-summary">
            <h2 className="font-display text-xl font-bold">Resumo</h2>
            <Line title="Experiência" value={tour.title} />
            <Line title="Data e horário" value={when} testid="summary-when" />
            <Line title="Participantes" value={guests} testid="summary-guests" />
            {quote && <>
                <div className="flex justify-between text-sm text-dim"><span>Valor principal{quote.units > 1 ? ` (${quote.units} equip.)` : ""}</span>
                    <span className="text-right">{pct > 0 && <span className="mr-2 line-through">{money(quote.original_price)}</span>}
                        <strong data-testid="summary-base">{money(quote.base)}</strong>
                        {pct > 0 && <span className="ml-2 rounded-full bg-neon-cyan/15 px-2 py-0.5 text-[10px] text-neon-cyan">-{pct}%</span>}</span></div>
                <Line title="Adicionais" value={money(quote.addons_total)} testid="summary-addons" />
                <Line title="Taxas" value={money(quote.fees)} testid="summary-fees" />
                <Line title="Descontos" value={`- ${money(quote.discount)}`} testid="summary-discount" />
                <Line title="Total" value={money(quote.total)} testid="summary-total" strong />
                <Line title="A pagar agora" value={money(quote.pay_now)} testid="summary-pay-now" />
                <Line title="Saldo a pagar depois" value={money(quote.balance)} testid="summary-balance" />
                {!quote.online_payment && <p className="text-xs leading-relaxed text-dim" data-testid="summary-payment-note">
                    Pagamento online desativado. Sinal de referência: {Number(quote.deposit_pct)}% ({money(quote.deposit)}), combinado com a equipe após a confirmação.</p>}
            </>}
            {couponCode && quote && <p data-testid="summary-coupon-status" className={`text-xs ${quote.coupon_status === "valid" ? "text-neon-teal" : "text-neon-coral"}`}>{COUPON_MSG[quote.coupon_status] || ""}</p>}
            {loading && <p className="text-xs text-dim">Calculando…</p>}
            {error && <p role="alert" className="text-xs text-neon-coral" data-testid="summary-error">{error}</p>}
            {!quote && !loading && !error && <p className="text-xs text-dim">Os valores são calculados pelo servidor após escolher data, horário e participantes.</p>}
        </aside>
    );
}
